import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'eligibleCourses',
})
export class EligibleCoursesPipe implements PipeTransform {
    transform(value: number | null | undefined) {
        if (!value) return '';

        switch (value) {
            case 1:
                return 'AICE Math 1 AS';
            case 2:
                return 'AICE MA&PR&ST 2 AL';
            case 4:
                return 'Algebra 1 / Algebra 1 Honors';
            case 8:
                return 'Algebra 2 / Algebra 2 Honors';
            case 16:
                return 'Geometry / Geometry Honors';
            case 32:
                return 'IB PRECALCULUS';
            case 64:
                return 'Pre-AICE Math 2 IG';
            case 128:
                return 'Pre-AICE Math 3 IG';
            case 256:
                return 'PRECALCULUS Honors';
            case 512:
                return 'English 4 / English 4 Honors';
            default:
                return '' + value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pipes/eligible-courses.pipe.ts